import React, { useContext, useState, useEffect, useRef } from "react";
import { toggleDislikeById, toggleLikeById } from "../../api/vod/vod";
import DislikeIcon from "../../assets/icons/svg/DislikeIcon";
import LikeIcon from "../../assets/icons/svg/LikeIcon";
import { SessionContext } from "../../context/SessionContext";
import localizationStrings from "../../statics/localization";
import { flowCopy } from "../../utils/flowCopy";

export default function LikeAction({ vod, newVodDetail }) {
  const [reaction, setReaction] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const version = useRef(0), pending = useRef(false);
  const { setShowLoginMessage, hasLoggedIn } = useContext(SessionContext);
  useEffect(() => {
    version.current++;
    pending.current = false;
    setBusy(false);
    setError(false);
    setReaction(vod?.interactions?.some(i => i.type === "VOD_LIKE") ? "like" : vod?.interactions?.some(i => i.type === "VOD_DISLIKE") ? "dislike" : null);
    return () => { version.current++; };
  }, [vod]);
  const toggle = async type => {
    if (!hasLoggedIn) { setShowLoginMessage(true); return; }
    if (!vod?.id || pending.current) return;
    const request = version.current;
    pending.current = true; setBusy(true); setError(false);
    try {
      const response = await (type === "like" ? toggleLikeById : toggleDislikeById)(vod.id);
      if (response?.data?.IsSucceeded === false || response?.data?.isSucceeded === false) throw new Error("Rejected");
      if (request === version.current) setReaction(value => value === type ? null : type);
    } catch (e) {
      if (request === version.current) setError(true);
    } finally {
      if (request === version.current) { pending.current = false; setBusy(false); }
    }
  };
  return <div style={{ display: "flex", gap: ".834vw" }}>
    {["like", "dislike"].map(type => <button key={type} type="button"
      disabled={busy} aria-busy={busy} aria-pressed={reaction === type}
      aria-label={localizationStrings[type]} onClick={() => toggle(type)}
      className={`action-button secondary ${reaction === type ? "selected" : ""}`}>
      <span className="icon">{type === "like" ? <LikeIcon/> : <DislikeIcon/>}</span>
      {newVodDetail && <span className={`action-label ${reaction === type ? "visible" : ""}`}>{localizationStrings[type]}</span>}
    </button>)}
    {error && <span role="alert">{flowCopy().error}</span>}
  </div>;
}
